var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"city-lab network-module-ai"},[_c('nav',{staticClass:"lab-crumb"},[_vm._v("网格平台 / AI案例生成")]),_c('ai-case-generator',{ref:"generator",attrs:{"kind":"network","page":""},on:{"close":_vm.back,"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }